module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Graph</span></div>\r\n\r\n<div id=\"lineColorProp\" class=\"row hide\">\r\n    <div class=\"prop-sublabel\">\r\n        <label>Line</label>\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n        <input id=\"lineColorPicker\" name=\"lineColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( lineColor ))
    ; __append("\"\r\n               style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\"/>\r\n        <input id=\"lineColor\" name=\"lineColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\"\r\n               value=\"")
    ; __append(escapeFn( lineColor ))
    ; __append("\"/>\r\n    </div>\r\n</div>\r\n<div id=\"barsColorProp\" class=\"row hide\">\r\n    <div class=\"col-md-1 prop-sublabel\">\r\n        <label>Bars</label>\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n        <input id=\"barColorPicker\" name=\"barColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( barColor ))
    ; __append("\"\r\n               style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\"/>\r\n        <input id=\"barColor\" name=\"barColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\"\r\n               value=\"")
    ; __append(escapeFn( barColor ))
    ; __append("\"/>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"prop-sublabel\">\r\n        <label>Axis</label>\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n        <input id=\"axisColorPicker\" name=\"axisColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( axisColor ))
    ; __append("\"\r\n               style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\"/>\r\n        <input id=\"axisColor\" name=\"axisColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\"\r\n               value=\"")
    ; __append(escapeFn( axisColor ))
    ; __append("\"/>\r\n    </div>\r\n</div>")
  }
  return __output;

}